import { Lightbulb, PawPrint } from "lucide-react"

import { cn } from "@/lib/utils"

type KuhlykTipProps = {
  title?: string
  text: string
  variant?: "default" | "warm" | "warning"
  className?: string
}

export function KuhlykTip({
  title = "Порада Кухлика",
  text,
  variant = "default",
  className,
}: KuhlykTipProps) {
  return (
    <div
      className={cn(
        "rounded-3xl border p-5 shadow-sm",
        variant === "default" &&
          "border-emerald-200 bg-gradient-to-br from-white to-emerald-50/70",
        variant === "warm" &&
          "border-amber-200 bg-gradient-to-br from-white to-amber-50/80",
        variant === "warning" &&
          "border-rose-200 bg-gradient-to-br from-white to-rose-50/80",
        className,
      )}
    >
      <div className="flex items-start gap-4">
        <div
          className={cn(
            "flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl shadow-sm",
            variant === "default" && "bg-emerald-100 text-emerald-800",
            variant === "warm" && "bg-amber-100 text-amber-800",
            variant === "warning" && "bg-rose-100 text-rose-800",
          )}
          aria-hidden="true"
        >
          {variant === "warning" ? (
            <PawPrint className="h-5 w-5" />
          ) : (
            <Lightbulb className="h-5 w-5" />
          )}
        </div>

        <div className="min-w-0">
          <div className="mb-1 text-sm font-semibold text-neutral-950">
            {title}
          </div>
          <p className="text-sm leading-7 text-neutral-700">{text}</p>
        </div>
      </div>
    </div>
  )
}
